"use client";
import Anchor from "@/components/common/Anchor";
import Layout from "@/components/common/Layout";
import List from "@/components/common/List";
import type { SecondaryNavLink } from "@/types/nav-bar";
import DropdownLinks from "./DropdownLinks";
import s from "./SecondaryNavDesktop.module.scss";

interface SecondaryNavDesktopProps {
  dropdownLinks: SecondaryNavLink[];
  links: SecondaryNavLink[];
  fullWidthLayout?: boolean;
}

export default function SecondaryNavDesktop(props: SecondaryNavDesktopProps) {
  const { dropdownLinks, links, fullWidthLayout } = props;

  return (
    <div className={s.wrapper}>
      <Layout fluid={fullWidthLayout} containerOnly>
        <div className={s.body}>
          <div>
            {dropdownLinks.length > 0 && (
              <DropdownLinks links={dropdownLinks} />
            )}
          </div>

          <div className={s.rightColumn}>
            {links.length > 0 && (
              <List
                items={links}
                renderItem={({ text, url, openInNewTab }) => (
                  <Anchor href={url} openInNewTab={openInNewTab}>
                    {text}
                  </Anchor>
                )}
                className={s.list}
              />
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
}
